var _defs, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.502,
    height: 61.503,
    viewBox: "0 0 61.502 61.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#2A7DE1;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 28.34,
    height: 28.34,
    rx: 14,
    transform: "translate(0 33.163)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 28.34,
    height: 28.34,
    rx: 14,
    transform: "translate(33.162 33.163)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 28.34,
    height: 28.34,
    rx: 14,
    transform: "translate(33.162)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 28.34,
    height: 28.34,
    rx: 14
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16.338,
    height: 16.338,
    rx: 8.169,
    transform: "translate(39.163 39.164)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.f8a4bbde7f7c86108a66f1a2c1718de2.svg";
export { ForwardRef as ReactComponent };